<template>
  <div>
    <template v-if="!alias">
      <div class="alert alert-info" role="alert" style="margin-top: 30px">
        <em>Loading the alias's details... Please wait.</em>
      </div>
    </template>
    <template v-else>
      <div class="m-2">
        <router-link
          :to="{
            name: 'domain-details',
            params: { domain: $route.params.domain },
          }"
          >Return to {{ $route.params.domain }} details.</router-link
        >
      </div>
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">
          {{ alias.alias }} <span class="badge badge-info">forwards to</span>
          {{ alias.forward }}
        </h1>
      </div>
      <div class="row">
        <div class="col-sm-8">
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h2 class="h3">Logs</h2>
          </div>

          <div v-if="logs && logs.length > 0">
            <div
              class="card mb-3"
              v-for="log in logs"
              v-bind:key="log.messageId"
            >
              <div class="card-header">
                <strong>{{ log.subject }}</strong>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-6">
                    <label>From: </label>
                    <span v-if="log.sender" class="badge badge-info">{{
                      log.sender.email
                    }}</span>
                    <span v-else class="badge badge-info">N/A</span>
                  </div>
                  <div class="col-sm-6 text-right">
                    <label>To: </label>
                    <span class="badge badge-primary" v-if="log.forward">
                      <template v-if="log.forward.name"
                        >{{ log.forward.name }}
                        <span class="data--subtle">{{
                          log.forward.email
                        }}</span></template
                      >
                      <template v-else>{{ log.forward.email }}</template>
                    </span>
                    <span class="badge badge-primary" v-else>N/A</span>
                  </div>
                </div>
              </div>
              <ul class="list-group list-group-flush">
                <li
                  v-for="event in log.events"
                  class="list-group-item"
                  v-bind:key="event.id"
                >
                  <div class="d-flex justify-content-between">
                    <strong
                      v-bind:class="'text-' + getTextState(event.status)"
                      >{{ event.status }}</strong
                    >
                    <time :datetime="event.created" :title="event.created">{{
                      event.created | relative(log.events[0].created)
                    }}</time>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span class="data"
                      ><strong>from</strong> {{ event.server }}</span
                    >
                    <span class="data"><strong>to</strong> {{ event.ip }}</span>
                  </div>
                  <div class="p-3 mt-2 bg-light">
                    <strong>{{ event.message }}</strong>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div v-else>
            <div
              class="alert alert-warning"
              role="alert"
              style="margin-top: 30px"
            >
              <em>No logs found for this alias.</em>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h2 class="h3">Last quotas</h2>
          </div>

          <template v-if="alias.events">
            <ul class="row">
              <li
                v-for="(value, date) in alias.events"
                v-bind:key="date"
                class="col-sm-6"
              >
                {{ date }}: <strong>{{ value }}</strong>
              </li>
            </ul>
          </template>
          <template v-else>
            <div
              class="alert alert-warning"
              role="alert"
              style="margin-top: 30px"
            >
              <em>No events found for this alias.</em>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alias: null,
      logs: null,
    };
  },
  created() {
    this.$http
      .get(
        "domains/" +
          this.$route.params.domain +
          "/aliases/" +
          this.$route.params.alias,
      )
      .then(
        (response) => {
          this.alias = response.body.alias;
        },
        (response) => {
          if (response.status === 401) return;
          alert("A fatal error occured!");
        },
      );

    this.$http
      .get("domains/" + this.$route.params.domain + "/logs", {
        params: { alias: this.$route.params.alias },
      })
      .then((response) => {
        this.logs = response.body.logs;
      });
  },
  methods: {
    getTextState(state) {
      state = state.toLowerCase();
      if (["queued", "delivered"].indexOf(state) > -1) {
        return "success";
      }
      if (state === "soft-bounce") {
        return "warning";
      }
      return "danger";
    },
  },
};
</script>
